<template>
  <div class="w-100">
    <div v-loading="isLoading" element-loading-text="Đang chuẩn bị dữ liệu..."
         element-loading-spinner="el-icon-loading"
         element-loading-background="#f5f5f5">
      <div class="d-flex m-2 ">
        <el-select v-model="selectedAccount" filterable default-first-option
                   placeholder="Tìm kiếm tài khoản..." size="sm"
                   class="flex-1" style="max-width: 450px" multiple>
          <el-option v-for="account in accounts" :key="account.accountId" :label="getAccountName(account)"
                     :value="account.accountId"></el-option>
        </el-select>
        <el-select v-model="selectedTagIds" filterable
                   placeholder="Lọc theo tag" size="sm" style="max-width: 450px"
                   class="flex-1 mx-2" multiple>
          <el-option v-for="tag in app.tags" :key="tag.id" :label="getTagName(tag)"
                     :value="tag.id"></el-option>
        </el-select>
        <el-select v-model="selectType" class="w-150px ">
          <el-option v-for="item in types" :key="item.val" :label="item.name"
                     :value="item.val">
          </el-option>
        </el-select>
        <div class="mx-2 text-center" style="padding-top: 1px">
          <DateRangePicker
            size="sm"
            ref="picker"
            opens="left"
            :locale-data="{ firstDay: 1, format: 'dd/mm/yyyy', applyLabel: 'Áp dụng', cancelLabel: 'Hủy' }"
            :minDate="'2019/01/01'"
            :singleDatePicker="false"
            :ranges="false"
            :showWeekNumbers="true"
            :showDropdowns="true"
            :autoApply="false"
            v-model="dateRange"
            :linkedCalendars="true"
          >
            <template v-slot:input="picker">
                <span style="line-height: 25px; padding: 0 10px;"
                >Từ <b>{{ picker.startDate.toLocaleDateString("vi") }}</b> &nbsp; &nbsp; Đến
                  <b> {{ picker.endDate.toLocaleDateString("vi") }} </b></span
                >
            </template>
          </DateRangePicker>
        </div>
        <div>
          <el-button size="medium" @click="fetchStatistic()" type="primary">Tổng hợp</el-button>
        </div>
      </div>
      <el-card class="m-2" v-if="slider.interval<100">
        <vue-slide-bar :speed="0.05" v-model="slider.interval" :showTooltip="false"
                       :lineHeight="10"
                       style="padding-top: 4px !important;"
                       :isDisabled="true" />
        <div class="mt-2  font-size-14">Đang tải dữ liệu {{ slider.interval }} %</div>
      </el-card>
      <div style="overflow-y: auto;max-height:calc(100vh - 160px);min-height:calc(100vh - 160px)"
           class="small-scrollbar">
        <div class="d-flex px-2 " style="height: 480px">
          <el-card class="flex-1">
            <div class="font-size-16 fw-semibold mb-1">Tỷ lệ theo hội thoại</div>
            <apexchart type="pie" height="380" :options="chartOptions_a" :series="series_a"></apexchart>
          </el-card>
          <div class="mx-1" />
          <el-card class="flex-1">
            <div class="font-size-16 fw-semibold mb-1">Tỷ lệ theo tin nhắn</div>
            <apexchart type="pie" height="380" :options="chartOptions_b" :series="series_b"></apexchart>
          </el-card>
        </div>
        <div>
          <el-card class="m-2">
            <div>
              <el-table :data="seriesAccount" height="500px">
                <el-table-column prop="" label="Tên tài khoản">
                  <template slot-scope="scope">
                    <span class="fw-semibold">{{ getNameAcc(scope.row.accountId) }}</span>
                  </template>
                </el-table-column>
                <el-table-column label="Hội thoại" width="200px">
                  <template slot-scope="scope">
                    <div style="min-width: 200px">
                      <div>Số lượng : {{ scope.row.totalConversation }}</div>
                      <div>Gửi qua Salework : {{ scope.row.totalConversationSent }}</div>
                      <div>Không qua Salework : {{ scope.row.totalConversation - scope.row.totalConversationSent }}
                      </div>
                    </div>
                  </template>
                </el-table-column>
                <el-table-column label="Tin đã gửi" width="200px">
                  <template slot-scope="scope">
                    <div style="min-width: 200px">
                      <div>Số lượng : {{ scope.row.webhookReceived }}</div>
                      <div>Gửi qua Salework : {{ scope.row.sent }}</div>
                      <div>Không qua Salework : {{ scope.row.webhookReceived - scope.row.sent }}</div>
                    </div>
                  </template>
                </el-table-column>
                <el-table-column label="Đã nhận" width="200px">
                  <template slot-scope="scope">
                    <div style="min-width: 200px">
                      <div>Số lượng : {{ scope.row.webhook }}</div>
                      <div>Chưa trả lời : {{ getUnReplyConversations(scope.row.accountId) }}</div>
                      <div>Chưa đọc : {{ getUnreadConversations(scope.row.accountId) }}</div>
                    </div>
                  </template>
                </el-table-column>
                <el-table-column label="Cuộc gọi" width="200px">
                  <template slot-scope="scope">
                    <div style="min-width: 200px">
                      <div>Cuộc gọi đến : {{ scope.row.incomingCall }}</div>
                      <div>Cuộc gọi đi : {{ scope.row.outgoingCall }}</div>
                      <div>Cuộc gọi nhỡ : {{ scope.row.missCall }}</div>
                      <div>Thời lượng : {{responseTime(scope.row.duration) }}</div>
                    </div>
                  </template>
                </el-table-column>

              </el-table>
              <div>

                <div class="d-flex justify-content-end pointer" v-if="seriesAccount.length > 0">
                  <el-button plain type="primary" size="small" @click="exportToXLSX" class="mt-2 d-flex align-items-center">
                    <span class="text-primary font-size-16">Xuất dữ liệu</span>
                    <span class="icon-download mx-1" style="display:inline-flex;" />
                  </el-button>
                </div>

              </div>
            </div>
          </el-card>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DateRangePicker from "vue2-daterange-picker";
import "vue2-daterange-picker/dist/vue2-daterange-picker.css";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";

export default {
  components: { DateRangePicker },
  name: "ConversationStatistical",
  data() {
    return {
      types: [
        { name: "Tất cả liên hệ", val: "all" },
        { name: "Cá nhân", val: "personal" },
        { name: "Nhóm", val: "group" },
        { name: "Zalo OA", val: "page" }
      ],
      selectType: "all",
      isLoading: false,
      dateRange: {
        startDate: new Date(),
        endDate: new Date()
      },
      accounts: [],
      selectedAccount: [],
      selectedTagIds: [],
      overviewId: "",
      seriesAccount: [],
      unreadAndNotReply: [],
      series_a: [],
      chartOptions_a: {
        labels: [],
        chart: {
          type: "donut"
        },
        responsive: [{
          breakpoint: 480,
          options: {
            chart: {
              width: 200
            },
            legend: {
              position: "bottom"
            }
          }
        }]
      },
      series_b: [],
      chartOptions_b: {
        chart: {
          type: "donut"
        },
        labels: [],
        responsive: [{
          breakpoint: 480,
          options: {
            chart: {
              width: 200
            },
            legend: {
              position: "bottom"
            }
          }
        }]
      },
      slider: {
        interval: 0,
        total: 0,
        index: 0
      },
      exportData: [],
      json_meta: [
        [
          {
            "key": "charset",
            "value": "utf-8"
          }
        ]
      ],
      json_fields: {
        "Tài khoản": "account",
        "Đã gửi": "sent",
        "Gửi qua Salework": "sent_1",
        "Không gửi qua Salework": "sent_2",
        "Hội thoại": "total",
        "Hội thoại gửi qua Salework": "total_1",
        "Hội thoại không gửi qua Salework": "total_2",
        "Đã nhận": "received",
        "Chưa trả lời": "unReply",
        "Chưa đọc": "unread",
        "Cuộc gọi đến": "incomingCall",
        "Cuộc gọi đi": "outgoingCall",
        "Cuộc gọi nhỡ": "missCall",
        "Thời lượng cuộc gọi (giây)": "duration"
      }
    };
  },
  methods: {
    responseTime(rpt) {
      let type = " giây";
      if (rpt >= 60 && rpt > 0) {
        rpt = rpt / 60;
        type = " phút";
        if (rpt >= 60) {
          rpt = rpt / 60;
          type = " giờ";
          if (rpt >= 24) {
            rpt = rpt / 24;
            type = " ngày";
            if (rpt >= 365) {
              type = " năm";
              rpt = rpt / 365;
            }
          }
        }
      }

      return rpt.toFixed(2) + type;
    },
    getTagName(tag) {
      if (tag.assign) {
        return tag.name + " (*)";
      }
      return tag.name;
    },
    getAccounts() {
      // this.$http.get("/api/account/getAll").then(resp => {
        this.accounts = this.app.accounts;
        this.fetchStatistic();
      // });
    },

    fetchStatistic() {
      let startTime = this.dateRange.startDate.setHours(0, 0, 0, 0);
      let endTime = this.dateRange.endDate.setHours(23, 59, 59, 999);
      this.overviewId = startTime.toString() + "_" + endTime.toString() + "_" + new Date().getTime();
      this.seriesAccount = [];
      this.series_a = [];
      this.series_b = [];
      this.unreadAndNotReply = [];
      let data = [];
      if (this.selectedAccount.length == 0) {
        this.accounts.forEach((acc) => {
          data.push(acc.accountId);
        });
      } else {
        data.push(...this.selectedAccount);
      }
      if (data.length > 0) {
        this.isLoading = true;
        this.$http.post("/api/statistic/overview", {
          startTime: startTime,
          endTime: endTime,
          statisticType: "conversation",
          id: this.overviewId,
          type: this.selectType,
          accountIds: data,
          tagIds: this.selectedTagIds
        }).then((res) => {
          this.slider.total = res.data;
          this.slider.index = 0;
        });
      }
    },
    getNameAcc(accountId) {
      let a = this.accounts.filter((p) => p.accountId == accountId)[0];
      return this.getAccountName(a);
    },
    updateSlider() {
      this.slider.index += 1;
      this.slider.interval = ((this.slider.index / this.slider.total) * 100).toFixed(2);
    },
    updateStatistic(data) {
      if (data.id == this.overviewId) {
        this.isLoading = false;
        let filter = this.seriesAccount.filter((acc) => acc.newId == data.newId);
        if (filter == null || filter.length == 0) {
          this.seriesAccount.push(data);
          this.updateSlider();
          if (this.slider.interval == 100) {
            this.calculateStatistic();
          }
        }
      }
    },
    calculateStatistic() {
      this.series_a = [];
      this.series_b = [];
      this.chartOptions_a.labels = [];
      let labels = [];
      this.seriesAccount = this.seriesAccount.sort((a, b) => {
        if (this.getNameAcc(b.accountId).toLowerCase() > this.getNameAcc(a.accountId).toLowerCase())
          return -1;
        return 1;
      });
      this.seriesAccount.forEach((acc) => {
        this.series_a.push(acc.totalConversation);
        this.series_b.push(acc.webhook + acc.webhookReceived);
        labels.push(this.getNameAcc(acc.accountId));
      });
      this.setOption(labels);
      this.exportData = [];
      this.seriesAccount.forEach((item) => {
        this.exportData.push({
          account: this.getNameAcc(item.accountId),
          sent: item.webhookReceived,
          sent_1: item.sent,
          sent_2: item.webhookReceived - item.sent,
          total: item.totalConversation,
          total_1: item.totalConversationSent,
          total_2: item.totalConversation - item.totalConversationSent,
          received: item.webhook,
          unReply: this.getUnReplyConversations(item.accountId),
          unread: this.getUnreadConversations(item.accountId),
          outgoingCall: item.outgoingCall,
          incomingCall: item.incomingCall,
          missCall: item.missCall,
          duration: item.duration
        });
      });
    },
    setOption(labels) {
      this.chartOptions_a = {
        chart: {
          type: "donut",
          toolbar: {
            show: true,
            offsetX: 0,
            offsetY: 0,
            tools: {
              download: true,
              selection: true,
              zoom: true,
              zoomin: true,
              zoomout: true,
              pan: true,
              reset: true,
              customIcons: []
            },
            export: {
              csv: {
                filename: undefined,
                columnDelimiter: ",",
                headerCategory: "category",
                headerValue: "value",
                dateFormatter(timestamp) {
                  return new Date(timestamp).toDateString();
                }
              },
              svg: {
                filename: undefined
              },
              png: {
                filename: undefined
              }
            },
            autoSelected: "zoom"
          }
        },
        colors: this.getRandomColors(20),
        labels: labels,
        responsive: [{
          breakpoint: 480,
          options: {
            chart: {
              width: 200
            },
            legend: {
              position: "bottom"
            }
          }
        }]
      };
      this.chartOptions_b = {
        chart: {
          type: "donut",
          toolbar: {
            show: true,
            offsetX: 0,
            offsetY: 0,
            tools: {
              download: true,
              selection: true,
              zoom: true,
              zoomin: true,
              zoomout: true,
              pan: true,
              reset: true,
              customIcons: []
            },
            export: {
              csv: {
                filename: undefined,
                columnDelimiter: ",",
                headerCategory: "category",
                headerValue: "value",
                dateFormatter(timestamp) {
                  return new Date(timestamp).toDateString();
                }
              },
              svg: {
                filename: undefined
              },
              png: {
                filename: undefined
              }
            },
            autoSelected: "zoom"
          }
        },
        colors: this.getRandomColors(20),
        labels: labels,
        responsive: [{
          breakpoint: 480,
          options: {
            chart: {
              width: 200
            },
            legend: {
              position: "bottom"
            }
          }
        }]
      };
    },
    getUnReplyConversations(accountId) {
      let filter = this.unreadAndNotReply.filter((acc) => acc.accountId == accountId);
      if (filter != null && filter.length > 0) {
        return filter[0].unReplyConversations;
      }
      return 0;
    },
    getUnreadConversations(accountId) {
      let filter = this.unreadAndNotReply.filter((acc) => acc.accountId == accountId);
      if (filter != null && filter.length > 0) {
        return filter[0].unreadConversations;
      }
      return 0;
    },
    exportToXLSX() {

      const ws = XLSX.utils.json_to_sheet(this.exportData, {
        header: Object.values(this.json_fields)
      });

      const headers = Object.keys(this.json_fields);
      XLSX.utils.sheet_add_aoa(ws, [headers], { origin: "A1" });

      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, "Thống kê");

      const wbout = XLSX.write(wb, { bookType: "xlsx", type: "array" });
      saveAs(new Blob([wbout], { type: "application/octet-stream" }), "data.xlsx");
    }
  },
  beforeDestroy() {
    this.$bus.$off("ConversationStatistical_event");
    this.$bus.$off("ConversationStatistical_unreadAndNotReply_event");
  },
  created() {
    // this.dateRange.startDate.setDate(this.dateRange.startDate.getDate());
    this.$bus.$on("ConversationStatistical_event", (data) => {
      this.updateStatistic(data);
    });
    this.$bus.$on("ConversationStatistical_unreadAndNotReply_event", (data) => {
      if (data.id == this.overviewId) {
        let filter = this.unreadAndNotReply.filter((acc) => acc.accountId == data.accountId);
        if (filter == null || filter.length == 0) {
          this.unreadAndNotReply.push(data);
          this.updateSlider();
        }
      }
    });
    this.getAccounts();
  }
};
</script>

<style scoped>

</style>
